import {GedFileDescription, IGedWebServiceClient} from "@resources/resources";
import {environment} from "@environments/environment";
import {ArianeElement, ArianeStore, CssInjectorService, CorrespondantStore} from "@digicerba/common";
import {Component} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'catalogue-dl-component',
  templateUrl: './catalogue-dl.component.html',
  host: {'class': 'page'}
})
export class CatalogueTelechargerComponent {

    context_lcsd: { url: string, code: string } = {url: null, code: null};

    context_telecharger: { documents: Array<GedFileDescription>, loading: boolean } = {documents: [], loading: true};
    context_specifiques: { documents: Array<GedFileDescription>, loading: boolean } = {documents: [], loading: true};
    context_tests: { documents: Array<GedFileDescription>, loading: boolean } = {documents: [], loading: true};

    constructor(private gedWebServiceClient: IGedWebServiceClient, arianeStore: ArianeStore, private cssInjector: CssInjectorService,
    private correspondantStore: CorrespondantStore, private http: Http) {

    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Formats de Catalogues",
        route: "/accueil"
      },
      {
        libelle: "Catalogue à télécharger",
        route: "/catalogue-telecharger"
      },
    ];

    arianeStore.updateElements(arianeElements);
  }

  isStrictFr() {
    let tags: Array<String> = this.correspondantStore.getCorrespondant().tags;
    return (tags.indexOf("fr") != -1);
  }

  ngOnInit() {
    let correspondants = this.correspondantStore.getCorrespondant();

      this.init("catanacerba", "context_telecharger");
      this.init("cataloguesspe", "context_specifiques");
      this.init("testdynamique", "context_tests");

    if (this.correspondantStore.getCorrespondants() == undefined || this.correspondantStore.getCorrespondants().length == 0) {
      this.context_lcsd.url = "LCSD_FR.hl7";
      return;
    }
    let tags: Array<String> = this.correspondantStore.getCorrespondant().tags;

    this.context_lcsd.code = this.correspondantStore.getCorrespondant().code;
    if (tags.indexOf("fr") != -1) {
      if (tags.indexOf("international") === -1) {
          // this.context_telecharger.url = "CatanaCerba_fr.appli";
        this.context_lcsd.url = "LCSD_" + this.correspondantStore.getCorrespondant().code + "_FR.hl7";
      }
      else if (tags.indexOf("international") != -1) {
          // this.context_telecharger.url = "CatanaCerba_fri.appli";
        this.context_lcsd.url = "LCSD_" + this.correspondantStore.getCorrespondant().code + "_FR.hl7";
      }
    } else if (tags.indexOf("en") != -1) {
        // this.context_telecharger.url = "CatanaCerba_en.appli";
      this.context_lcsd.url = "LCSD_" + this.correspondantStore.getCorrespondant().code + "_GB.hl7";
    } else {
        // this.context_telecharger.url = "CatanaCerba_en.appli";
      this.context_lcsd.url = "LCSD_" + this.correspondantStore.getCorrespondant().code + "_GB.hl7";
    }
    this.http.get(environment.mediaBaseUrl + this.context_lcsd.url).subscribe(() => {
      return this.context_lcsd.url;
    }, () => {
      if (tags.indexOf("fr") != -1) {
        this.context_lcsd.url = "LCSD_FR.hl7";
        this.context_lcsd = {...this.context_lcsd};
      } else {
        this.context_lcsd.url = "LCSD_GB.hl7";
        this.context_lcsd = {...this.context_lcsd};
      }
    });
  }

    private init(tagValue: string, ctxName) {
        this.gedWebServiceClient.searchFilesByTag({tag: tagValue})
            .catch(error => {
                console.error("load documents " + tagValue + " error: " + error);
                return Observable.of([]);
            }).subscribe(data => {
            this[ctxName] = {documents: data, loading: false};
        });

        // this[ctxName] = {documents: [
        //{  url: 'http://google.com', nom: 'google', locale: 'IN' },
        //{  url: 'http://asi.fr', nom: 'asi', locale: 'IN' },
        //{  url: 'https://www.7-zip.org/a/7z1801.exe', nom: '7zip', locale: 'IN' },
        //{  url: 'http://www.lab-cerba.com/images/catalogue/pdf/Installation_FR.pdf', nom: 'Installation FR', locale: 'IN' },
        //{  url: 'http://www.lab-cerba.com/images/catalogue/pdf/Installation_EN.pdf', nom: 'Installation EN', locale: 'IN' }
        //], loading: false}
    }

  ngAfterViewInit() {
    this.cssInjector.injectCss("catalogue-examens/catalogue-examens.css");
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-dl/catalogue-dl.component.ts